import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Mail, Send, BellRing } from "lucide-react";
import { API } from "@/lib/api";

const inputCls =
  "w-full rounded-xl bg-white/5 border border-white/15 px-4 py-3 text-white placeholder-gray-500 focus:outline-none focus:border-[#D4AF37]/60 transition-colors text-sm";

export default function AdminNotifications({ auth }) {
  const [form, setForm] = useState({ notify_email: "", telegram_enabled: false, telegram_token: "", telegram_chat_id: "" });
  const [saving, setSaving] = useState(false);
  const [testing, setTesting] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.type === "checkbox" ? e.target.checked : e.target.value });

  useEffect(() => {
    axios.get(`${API}/admin/settings/notifications`, auth).then((r) => setForm(r.data)).catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await axios.put(`${API}/admin/settings/notifications`, form, auth);
      toast.success("პარამეტრები შენახულია");
    } catch {
      toast.error("შენახვა ვერ მოხერხდა");
    } finally {
      setSaving(false);
    }
  };

  const test = async () => {
    setTesting(true);
    try {
      const { data } = await axios.post(`${API}/admin/settings/notifications/test`, {}, auth);
      const parts = Object.entries(data).map(([k, v]) => `${k === "email" ? "Email" : "Telegram"}: ${v}`);
      toast.success("ტესტის შედეგი — " + parts.join(" · "), { duration: 6000 });
    } catch {
      toast.error("ტესტი ვერ გაიგზავნა");
    } finally {
      setTesting(false);
    }
  };

  return (
    <div className="max-w-xl space-y-8" data-testid="admin-notifications-section">
      <p className="text-sm text-gray-400 leading-relaxed">
        ახალი განაცხადის შესვლისას მიიღებ მყისიერ შეტყობინებას ელფოსტით და სურვილისამებრ Telegram-ით.
      </p>
      <form onSubmit={save} className="card-lux p-7 space-y-5">
        <div>
          <label className="block text-xs text-gray-400 mb-1.5 flex items-center gap-1.5"><Mail className="w-3.5 h-3.5 text-[#D4AF37]" /> შეტყობინების ელფოსტა</label>
          <input type="email" required data-testid="notify-email-input" value={form.notify_email} onChange={set("notify_email")} className={inputCls} placeholder="you@example.com" />
        </div>
        <label className="flex items-center gap-3 text-sm text-gray-300 cursor-pointer">
          <input type="checkbox" data-testid="telegram-enabled-toggle" checked={form.telegram_enabled} onChange={set("telegram_enabled")} className="w-4 h-4 accent-[#D4AF37]" />
          Telegram შეტყობინებების ჩართვა
        </label>
        {form.telegram_enabled && (
          <>
            <div>
              <label className="block text-xs text-gray-400 mb-1.5">Telegram Bot Token</label>
              <input type="password" data-testid="telegram-token-input" value={form.telegram_token} onChange={set("telegram_token")} className={inputCls} placeholder="123456:ABC-DEF..." />
              <p className="text-xs text-gray-500 mt-1.5">შექმენი ბოტი @BotFather-ით და ჩააგდე ტოკენი აქ.</p>
            </div>
            <div>
              <label className="block text-xs text-gray-400 mb-1.5">Chat ID</label>
              <input data-testid="telegram-chatid-input" value={form.telegram_chat_id} onChange={set("telegram_chat_id")} className={inputCls} placeholder="123456789" />
              <p className="text-xs text-gray-500 mt-1.5">მიწერე შენს ბოტს ნებისმიერი შეტყობინება, შემდეგ გაიგე Chat ID @userinfobot-ით.</p>
            </div>
          </>
        )}
        <div className="flex gap-3">
          <button type="submit" disabled={saving} data-testid="notify-save-btn" className="btn-gold !py-2.5 !px-6 text-sm disabled:opacity-60">
            {saving ? "ინახება..." : "შენახვა"}
          </button>
          <button type="button" onClick={test} disabled={testing} data-testid="notify-test-btn" className="btn-ghost !py-2.5 !px-6 text-sm disabled:opacity-60">
            <BellRing className="w-4 h-4" /> {testing ? "იგზავნება..." : "ტესტის გაგზავნა"}
          </button>
        </div>
      </form>
      <p className="text-xs text-gray-500 flex items-center gap-2">
        <Send className="w-3.5 h-3.5" /> ცვლილებების შენახვის შემდეგ დააჭირე "ტესტის გაგზავნა" დასამოწმებლად.
      </p>
    </div>
  );
}
